import { AHText, AHTextFonts, Card, SectionHeader } from "arkh";
import React from "react";

import { graphql, useMutation } from "react-relay";

import { IntegrationLogo } from "./components/Logos/Logos";
import { IntegrationTilTidCreateScreenMutation } from "./__generated__/IntegrationTilTidCreateScreenMutation.graphql";
import { useAlert } from "../../common/Alert";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { useIsStoresprintAdmin } from "@/src/useHasFeatureFlag";

export function IntegrationTilTidCreateScreen() {
  const isStoresprintSuperuser = useIsStoresprintAdmin();
  const Alert = useAlert();
  const [customerId, setCustomerId] = React.useState("");
  const [unitId, setUnitId] = React.useState("1");
  const [addMutation, pending] =
    useMutation<IntegrationTilTidCreateScreenMutation>(graphql`
      mutation IntegrationTilTidCreateScreenMutation(
        $customerId: String!
        $unitId: String
      ) {
        store {
          activateIntegrationTilTid(customerId: $customerId, unitId: $unitId) {
            id
            name
          }
        }
      }
    `);

  const add = () => {
    if (pending) {
      return;
    }
    addMutation({
      onError: () => {
        Alert.error("Fel inträffade");
      },
      onCompleted: (v) => {
        Alert.alert(
          "Integration tillagd",
          "Integrationen aktiverad för butik: " +
            (v.store.activateIntegrationTilTid?.name ?? "")
        );
      },
      variables: {
        customerId,
        unitId,
      },
    });
  };

  const isValid = customerId !== "" && unitId !== "" && isStoresprintSuperuser;

  return (
    <IntegrationActivateScreen
      isActivating={pending}
      isValid={isValid}
      onActivate={add}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="tiltid" />}
        />
      }
      activation={
        <>
          {isStoresprintSuperuser ? (
            <>
              <SectionHeader>
                <SectionHeader.Title>
                  Lägg till integration med TIL-TID. Obs. Detta visas enbart för
                  storesprint super-admins.
                </SectionHeader.Title>
                <SectionHeader.Description>
                  Kontrollera att siffrorna är korrekta och stämmer överens med
                  butiken. Det går inte att ta bort en integration när den är
                  tillagd.
                </SectionHeader.Description>
              </SectionHeader>

              <IntegrationActivateScreen.Input
                value={customerId}
                onChangeText={setCustomerId}
                placeholder="customer-id"
                label="customer-id"
                type="api-key"
              />
              <IntegrationActivateScreen.Input
                value={unitId}
                onChangeText={setUnitId}
                placeholder="unit-id"
                label="unit-id"
                type="api-key"
              />
            </>
          ) : (
            <Card color="surface-primary" defaultBorder>
              <AHText type="body-big">
                För att aktivera integration med TIL-Tid, skicka ett mail till
                <AHText font={AHTextFonts.BOLD} style={{ fontSize: 15 }}>
                  {" "}
                  support@tiltid.se{" "}
                </AHText>
                och be dem aktivera integration med StoreSprint.
              </AHText>
            </Card>
          )}
        </>
      }
    />
  );
}
